import { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-grid-system';
import { CreateTenantForm } from '../organism';
import styled from 'styled-components';
import { BackButton, LoadingSpinner } from '../atoms';
import { useLocation, useNavigate } from 'react-router';
import {
  useErrorHandlerContext,
  useOpeningElementsControllerContext,
  useUserLanguage,
} from '@/customHooks';
import { CreateTenantMutation, UpdateTenantMutation, useGetTenantDetailLazyQuery } from '@/graphql/generated';
import { TenantDeatils } from '@/custom-types';
import { FetchResult } from '@apollo/client';

const textsData = {
  en: {
    title: 'Tenant',
    create: 'Add',
    edit: 'Edit',
    detail: 'Deatil',
    confirmation: {
      create: {
        title: 'Tenant has been created',
        description: (firstName: string, lastName: string) => `User ${firstName} ${lastName} has been created succesfully`,
      },
      update: {
        title: 'Tenant has been updated',
        description: (firstName: string, lastName: string) => `User ${firstName} ${lastName} has been updated succesfully`,
      }
    }
  },
  es: {
    title: 'Inquilino',
    create: 'Agregar',
    edit: 'Editar',
    detail: ', detalles',
    confirmation: {
      create: {
        title: 'Inquilino creado con éxito',
        description: (firstName: string, lastName: string) => `${firstName} ${lastName} fue creado con éxito`,
      },
      update: {
        title: 'Inquilino actualizado con exito',
        description: (firstName: string, lastName: string) => `${firstName} ${lastName} fue actualizado con éxito`,
      }
    }
  }
}

const StyledContainer = styled(Container)`
  padding-top: ${({ theme }) => theme.spacing.lg};
  padding-bottom: ${({ theme }) => theme.spacing.lg};
`

const FormContainer = styled(Col)`
  & > form {
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
    border-radius: ${({ theme }) => theme.border.radius.base};
  } 
`
export const CreateTenantFormPage = () => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  const { confirmDialogModalOpen } = useOpeningElementsControllerContext()

  const [currentTenant, setCurrenTenant] = useState<TenantDeatils | null>(null)

  const [titleText, setTitleText] = useState(`${texts.create} ${texts.title}`)

  const navigate = useNavigate()

  const location = useLocation()

  const { open: errorHandle } = useErrorHandlerContext()

  const [getTenant, { loading }] = useGetTenantDetailLazyQuery()

  useEffect(() => {
    if (location.state) {
      if (location.state.readOnly) setTitleText(`${texts.title} ${texts.detail}`)
      else setTitleText(`${texts.edit} ${texts.title}`)

      getTenant({
        variables: {
          id: location.state.tenantId
        }
      })
      .then((response) => setCurrenTenant(response.data?.tenant || null))
      .catch(errorHandle)
    }
  }, [location.state?.tenantId, getTenant])

  const onCreateSuccess = (response: FetchResult<CreateTenantMutation> | FetchResult<UpdateTenantMutation>) => {
    if (response.data && 'createTenant' in response.data) {
      const user = response.data?.createTenant
      if (user.__typename === 'TenantOutput') {
        confirmDialogModalOpen({
          title: texts.confirmation.create.title,
          description: texts.confirmation.create.description(user.firstName, user.lastName),
        })
        navigate(-1)
      }
    } else if (response.data && 'updateTenant' in response.data) {
      const user = response.data?.updateTenant
      confirmDialogModalOpen({
        title: texts.confirmation.update.title,
        description: texts.confirmation.update.description(user.firstName, user.lastName)
      })
      navigate(-1)
    } 
  }

  return (
    <StyledContainer>
      {
        loading
        ? (
          <Row>
            <Col>
              <LoadingSpinner />
            </Col>
          </Row>
        )
        : (
          <>
            <Row align='center'>
              <Col xs="content">
                <BackButton />
              </Col>
              <Col>
                <h2>{titleText}</h2>
              </Col>
            </Row>
            <Row>
              <FormContainer>
                <CreateTenantForm
                  tenantDetail={currentTenant}
                  activity={location.state ? 'updating' : 'creating'}
                  readOnly={!!location.state?.readOnly}
                  onSuccess={onCreateSuccess}
                />
              </FormContainer>
            </Row>
          </>
        )
      }
    </StyledContainer>
  )
}